export let ZSIQLauncherModes = /*#__PURE__*/function (ZSIQLauncherModes) {
  ZSIQLauncherModes["ALWAYS"] = "LAUNCHER_VISIBILITY_MODE_ALWAYS";
  ZSIQLauncherModes["NEVER"] = "LAUNCHER_VISIBILITY_MODE_NEVER";
  ZSIQLauncherModes["WHEN_ACTIVE_CHAT"] = "LAUNCHER_VISIBILITY_MODE_WHEN_ACTIVE_CHAT";
  return ZSIQLauncherModes;
}({});
//# sourceMappingURL=Launcher.js.map